import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { Grid } from '@mui/material';
// components
import { RHFTextField, RHFSelect, RHFDatePicker, RHFNumericField } from '../../../../../components/hook-form';
import CardSection from '../../../../../components/card-section';

//-------------------------------------------------------------------------------------------------

const OwnerOfficerFields = ({ onRemove, isRemoveDisabled, index, setPayrollInState, initialPayroll }) => {
  // state
  const [payroll, setPayroll] = useState(initialPayroll);

  const handlePayrollChange = (event) => {
    setPayrollInState(event.target.value, index);
    setPayroll(event.target.value);
  };

  return (
    <CardSection title={`Owner / Officer #${index + 1}`} onRemove={() => onRemove(index)} isRemoveDisabled={isRemoveDisabled}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={1}>
          <RHFTextField name={`ownersOfficers[${index}].state`} label={'State'} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <RHFTextField name={`ownersOfficers[${index}].locNumber`} label={'Loc #'} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <RHFTextField name={`ownersOfficers[${index}].name`} label={'Name'} />
        </Grid>
        <Grid item xs={12} sm={2}>
          <RHFDatePicker clearable name={`ownersOfficers[${index}].dateOfBirth`} label={'DOB'} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <RHFTextField name={`ownersOfficers[${index}].title`} label={'Title'} />
        </Grid>
        <Grid item xs={12} sm={3}>
          <RHFTextField name={`ownersOfficers[${index}].ownershipPercentage`} label={'Ownership %'} type="number" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <RHFTextField name={`ownersOfficers[${index}].duties`} label={'Duties'} />
        </Grid>
        <Grid item xs={12} sm={2}>
          <RHFNumericField name={`ownersOfficers[${index}].payroll`} value={payroll} label={'Payroll'} onChange={handlePayrollChange}/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <RHFSelect
            name={`ownersOfficers[${index}].incExc`}
            label={'Inc / Exc'}
            options={['Include', 'Exclude']}
          />
        </Grid>
      </Grid>
    </CardSection>
  );
}

OwnerOfficerFields.propTypes = {
  onRemove: PropTypes.func,
  isRemoveDisabled: PropTypes.bool,
  index: PropTypes.number,
  setPayrollInState: PropTypes.func,
  initialPayroll: PropTypes.string,
};

export default OwnerOfficerFields;
